import { l } from '../lib/imports'
import { common } from '../main/common-sidecar'

let list: string[] = []
let eatenTimer = 0
let isLeftReleased = false
let isLeftDown = false
let isLeftFirstDown = false
let isLeftFirstDownPrimer = false

let isRightReleased = false
let isRightDown = false
let isRightFirstDown = false
let isRightFirstDownPrimer = false

export function create() {
  let ps = common.getPhaserScene()

  ps.input.on('pointerup', (pointer: { x: number; y: number }) => {
    isLeftReleased = true
    isLeftDown = false
    isRightReleased = true
    isRightDown = false
  })
  ps.input.on('pointerdown', (pointer: { x: number; y: number }) => {
    if (ps.game.input.activePointer.rightButtonDown()) {
      isRightFirstDownPrimer = true
      isRightDown = true
    } else {
      isLeftFirstDownPrimer = true
      isLeftDown = true
    }
  })
}

export function update(name: string, isOpen: boolean) {
  if (isOpen) {
    list.push(name)
    tempEat()
  } else {
    if (list.indexOf(name) !== -1) {
      tempEat()
      list = l.filter(list, (c) => c !== name)
    }
  }
}

export function updateAll() {
  if (isLeftFirstDown) {
    isLeftFirstDown = false
  }
  if (isLeftFirstDownPrimer) {
    isLeftFirstDown = true
    isLeftFirstDownPrimer = false
  }

  if (isRightFirstDown) {
    isRightFirstDown = false
  }
  if (isRightFirstDownPrimer) {
    isRightFirstDown = true
    isRightFirstDownPrimer = false
  }

  if (list.length > 0) {
    eatenTimer = 3
  } else {
    if (isLeftReleased && isRightReleased) {
      eatenTimer--
    }
  }
}

export function isEaten() {
  return eatenTimer > 0 || list.length > 0
}

export function tempEat() {
  isLeftReleased = false
  isRightReleased = false
  eatenTimer = 3
}
export function isPrimaryDownAndUneaten() {
  return isLeftDown && !isEaten()
}
export function isPrimaryFirstDownAndUneaten() {
  return isLeftFirstDown && !isEaten()
}
export function isSecondaryDownAndUneaten() {
  return isRightDown && !isEaten()
}
export function isSecondaryFirstDownAndUneaten() {
  return isRightFirstDown && !isEaten()
}

export function getMouseState() {
  return {
    left: isLeftDown && !isEaten(),
    leftFirst: isLeftFirstDown && !isEaten(),
    right: isRightDown && !isEaten(),
    rightFirst: isRightFirstDown && !isEaten(),
  }
}
